import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import {
    MenuInstructionType,
    useDeleteMenuInstructionsMutation,
    useUpdateMenuInstructionsMutation,
} from 'data/__generated__';
import { CustomMenuInstruction } from 'pages/MicrostoreMenus/MicrostoreMenuQuantities/types';
import { toast } from 'react-toastify';

export type MenuInstruction = {
    siteId: string;
    categoryId: string;
    date: string;
    value: number;
    type: MenuInstructionType;
};

export function UpdateMenuQuantitiesButton({ menuInstructions }: { menuInstructions: CustomMenuInstruction[] }) {
    const [updateMenuInstructions, { loading: updateLoading }] = useUpdateMenuInstructionsMutation();
    const [deleteMenuInstructions, { loading: deleteLoading }] = useDeleteMenuInstructionsMutation();

    async function handleClick() {
        try {
            const menuInstructionsToDelete = menuInstructions
                .filter((instruction) => instruction.value == null || instruction.value === undefined)
                .map((instruction) => ({
                    date: instruction.date,
                    microstoreColumnId: instruction.microstoreColumnId,
                    categoryId: instruction.categoryId,
                    type: instruction.type,
                }));

            // Type guard pour s'assurer que value est un number
            const hasValidValue = (
                instruction: CustomMenuInstruction,
            ): instruction is CustomMenuInstruction & { value: number } => {
                return instruction.value !== null && instruction.value !== undefined;
            };

            const menuInstructionsToUpdate = menuInstructions.filter(hasValidValue).map((instruction) => ({
                ...instruction,
                value: instruction.value, // Maintenant TypeScript sait que value est un number
            }));

            if (menuInstructionsToUpdate.length > 0) {
                await updateMenuInstructions({
                    variables: {
                        menuInstructionInputs: menuInstructionsToUpdate,
                    },
                });
            }
            if (menuInstructionsToDelete.length > 0) {
                await deleteMenuInstructions({
                    variables: {
                        menuInstructionDeleteInputs: menuInstructionsToDelete,
                    },
                });
            }
            toast.success('Les instructions de menu ont bien été mises à jour');
        } catch (error) {
            toast.error(`Impossible de mettre à jour les instructions de menu: ${error}`);
        }
    }

    return (
        <TotemPrimaryButton
            disabled={updateLoading || deleteLoading || menuInstructions.length === 0}
            onClick={handleClick}
        >
            Enregistrer
        </TotemPrimaryButton>
    );
}
